import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './submissionSuccess.module.scss'
import { RouterBtn } from 'components/generic/router/links'
import { PageUrls as ProfileUrls, SubPaths } from 'components/profile/ProfileRouter/ProfileRouter'
import { ReactComponent as SuccessIcon } from 'images/icons/icn_tick_circle.svg'
import MainContainer from 'components/generic/MainContainer'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { Redirect, useLocation } from 'react-router'
import { clearLastSubmittedSocialMatch } from 'actions/social-matches-actions'
import classNames from 'classnames'
import BtnSecondary from 'components/generic/BtnSecondary'
import { goToMyScoresLink } from './PostScore'
import { ConstantQueryParamValues, QueryParamNames } from 'types/global'
import withOnlyAllowLoggedIn from 'components/generic/hoc/withOnlyAllowLoggedIn'
import { createQueryString } from 'constants/global'

const SubmissionSuccess = () => {
  const { t: tSocialMatches } = useTranslation('strSocialMatches')
  const dispatch = useDispatch()
  const { state } = useLocation<{ fromMyScores?: boolean }>()
  const lastSubmitted = useSelector((state: AppState) => state.socialMatches.lastSubmitted)
  const submitted = useRef(lastSubmitted)

  useEffect(() => {
    dispatch(clearLastSubmittedSocialMatch())
  }, [dispatch])

  if (!lastSubmitted && !submitted.current) {
    return <Redirect push to={{ pathname: ProfileUrls.Profile, hash: SubPaths.PostScore }} />
  }

  return (
    <MainContainer className={styles.wrapper}>
      <div className={styles.iconCheckmark} aria-hidden>
        <SuccessIcon />
      </div>

      <h1 className={classNames(styles.title, styles.mt12, styles.mb24)}>
        {tSocialMatches('postScore.success.title')}
      </h1>
      <p className={styles.mb16}>{tSocialMatches('postScore.success.list.info')}</p>
      <ul className={classNames(styles.list, styles.mb0)}>
        <li className={styles.mb16}>{tSocialMatches('postScore.success.list.1')}</li>
        <li className={styles.mb0}>{tSocialMatches('postScore.success.list.2')}</li>
      </ul>
      <nav className={styles.btnsContainer}>
        {state?.fromMyScores ? (
          <RouterBtn
            type='btnSecondary'
            to={{
              pathname: ProfileUrls.Profile,
              search: createQueryString({
                queryParams: {
                  [QueryParamNames.PROFILE_OWN_PROFILE_FLAG]: 'true',
                  [QueryParamNames.PROFILE_SECTION]:
                    ConstantQueryParamValues.PROFILE_RESULTS_SECTION,
                  [QueryParamNames.PROFILE_RESULTS_SUB_SECTION]:
                    ConstantQueryParamValues.PROFILE_SOCIAL_MATCHES_RESULTS_SUB_SECTION,
                },
              }),
            }}
          >
            {tSocialMatches('postScore.success.btn.back')}
          </RouterBtn>
        ) : (
          <BtnSecondary size='medium' href={goToMyScoresLink}>
            {tSocialMatches('postScore.success.btn.back')}
          </BtnSecondary>
        )}
        <RouterBtn
          to={{ pathname: ProfileUrls.Profile, hash: SubPaths.PostScore, state }}
          type='btnPrimary'
        >
          {tSocialMatches('postScore.success.btn.submitNew')}
        </RouterBtn>
      </nav>
    </MainContainer>
  )
}

export default withOnlyAllowLoggedIn(SubmissionSuccess)
